import React from 'react';
import { BiLogoFacebook } from 'react-icons/bi';
import { BsPinterest } from 'react-icons/bs';
import { AiFillInstagram } from 'react-icons/ai';
import { FaSquareXTwitter } from 'react-icons/fa6';
import { Fade } from 'react-reveal';

function Footer() {
  return (
    <footer>
    <div className="about"> <Fade bottom left>
    <h2>ABOUT US</h2>
      <p>At Explore Era, we are a community of avid travelers, adventurers, and storytellers who share a common passion for exploring the world. Our journey began with a simple idea: to create a platform where the spirit of discovery and the love for travel could thrive. What sets us apart is our unwavering commitment to uncovering the hidden gems, embracing diverse cultures, and connecting with people from all walks of life.</p>
      </Fade>
    </div>

      <Fade right bottom>
    <div className="social">
      <h2>STAY CONNECTED VIA</h2>
        <BiLogoFacebook className='icons' />
        <AiFillInstagram className='icons' />
        <FaSquareXTwitter className='icons' />
        <BsPinterest className='icons' />
    </div> </Fade>

    </footer>
  )
}

export default Footer;